import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Menu as AriaMenu, Separator as AriaSeparator } from "react-aria-components";
import * as styles from "./Dropdown.css.js";
import { Popover } from "./Popover.js";
import { DropdownItemContext } from "./shared/DropdownItemContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DropdownSeparator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(AriaSeparator, {
      className: styles.separator
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function DropdownMenu(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? "m" : t1;
  let t2;
  if ($[3] !== size) {
    t2 = {
      size
    };
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const contextValue = t2;
  let t3;
  if ($[5] !== props) {
    t3 = /*#__PURE__*/_jsx(AriaMenu, {
      className: styles.menuContainer,
      ...props,
      children: props.children
    });
    $[5] = props;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== contextValue || $[8] !== t3) {
    t4 = /*#__PURE__*/_jsx(DropdownItemContext.Provider, {
      value: contextValue,
      children: t3
    });
    $[7] = contextValue;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function Dropdown(t0) {
  const $ = _c(18);
  let children;
  let isOpen;
  let onOpenChange;
  let placement;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      placement,
      isOpen,
      onOpenChange,
      width: t1,
      size: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isOpen;
    $[3] = onOpenChange;
    $[4] = placement;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    children = $[1];
    isOpen = $[2];
    onOpenChange = $[3];
    placement = $[4];
    props = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const width = t1 === undefined ? 64 : t1;
  const size = t2 === undefined ? "m" : t2;
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== size) {
    t3 = /*#__PURE__*/_jsx(DropdownMenu, {
      size: size,
      ...props,
      children: children
    });
    $[8] = children;
    $[9] = props;
    $[10] = size;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isOpen || $[13] !== onOpenChange || $[14] !== placement || $[15] !== t3 || $[16] !== width) {
    t4 = /*#__PURE__*/_jsx(Popover, {
      placement: placement,
      isOpen: isOpen,
      onOpenChange: onOpenChange,
      width: width,
      children: t3
    });
    $[12] = isOpen;
    $[13] = onOpenChange;
    $[14] = placement;
    $[15] = t3;
    $[16] = width;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export { MenuTrigger as DropdownTrigger } from "react-aria-components";
//# sourceMappingURL=Dropdown.js.map